import { render, staticRenderFns } from "./ztChip.vue?vue&type=template&id=412168a1"
import script from "./ztChip.vue?vue&type=script&lang=js"
export * from "./ztChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports